import { gql } from '@apollo/client';

export const PUBLIC_FANTASY_LEAGUE_MEMBER_INFO = gql`
  query PublicFantasyLeagueMemberInfo($fantasyLeagueMemberId: ID!) {
    publicFantasyLeagueMemberInfo(fantasyLeagueMemberId: $fantasyLeagueMemberId) {
      fantasyLeagueMemberId
      teamName
      players {
        id
        createdAt
        nick
        name
        lastName
        image
        role
        marketValue
        totalScore
        lastWeekNumber
        lastWeekScore
        team {
          id
          competition {
            id
            code
            displayName
            rank
          }
          createdAt
          nameShow
          shield
          shieldPng
          shortName
        }
      }
    }
  }
`;

